<!-- =========================================================================================
  File Name: makeWithdrawal.vue
  Description: Withdrawal index page
  ----------------------------------------------------------------------------------------
  Author: Faruk Nikmorad
  Auth Date: 2020-09-08
========================================================================================== -->
<template>
  <div id="page-withdrawal-create">
    <vx-card >
      <div id="loadingTab" class="vx-row w-full">
        
        <form-wizard class=" w-full" ref="formWizard" color="rgba(var(--vs-primary), 1)" errorColor="rgba(var(--vs-danger), 1)" :title="null" :subtitle="null" :nextButtonText="$t('İleri')" :backButtonText="$t('Geri')" :finishButtonText="$t('MakeWithdrawal')" @on-complete="ProcessWithdrawal">
          
          <tab-content :title="$t('ProviderMethods')" class="mb-5" icon="feather icon-home" :before-change="validateStep1">
            <form data-vv-scope="step-1">
              <div class="vx-col w-full">
                <provider-grid :selectedItem = "selectedItem" :data="providerMethodList" @set-selected-provider="updateSelectedItem"></provider-grid>
              </div>
            </form>
          </tab-content>

          <tab-content :title="$t('Account') + ' & ' + $t('Amount')" class="mb-5" icon="feather icon-briefcase">
            <form data-vv-scope="step-2">
              <div class="vx-col w-full">
                <create-withdrawal ref="CreateWithdrawal" :selectedItem = "selectedItem" :data="providerMethodList"></create-withdrawal>
              </div>
            </form>
          </tab-content>

        </form-wizard>

      </div>
    </vx-card>
  </div>
</template>

<script>
import ProviderList from '@/views/components/transaction/ProviderList.vue'
import ProviderGrid from '@/views/components/transaction/ProviderGrid.vue'
import createWithdrawal from '@/views/components/transaction/createWithdrawal.vue'
import CreateDepositCrypto from '@/views/components/transaction/CreateDepositCrypto.vue'
import moduleTransactionMng from '@/store/transaction-mng/moduleTransactionMng.js'
import { FormWizard, TabContent, WizardStep } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

export default {
  components:{
    ProviderList,
    createWithdrawal,
    ProviderGrid,
    FormWizard,
    TabContent,
    WizardStep,
    CreateDepositCrypto
  },
  data () { 
    return {
      selectedItem: -1,
      providerMethodList: [],
      CryptoInfo: {}
    }
  },
  methods: {

    updateSelectedItem (newValue) {
      this.selectedItem = newValue
      if (this.selectedItem >= 0) this.$refs.formWizard.nextTab()
    },
    ProcessWithdrawal () {
      this.$refs.CreateWithdrawal.startProcess()
    },
    validateStep1 () {
      return new Promise((resolve, reject) => {
        if (this.selectedItem >= 0) {
          resolve(true)
        } else {
          reject('correct all values')
        }
      })
    },
    validateStep2 () {
      return new Promise((resolve, reject) => {
        this.$vs.loading({
          container: '#loadingTab',
          type: 'sound',
          scale: 1
        })
        this.$refs.CreateDeposit.Process()
          .then((res) => {
            this.$vs.loading.close('#loadingTab > .con-vs-loading')
            if (this.selectedItem != 7 && this.selectedItem != 8) {
              if (res.data.isSuccess) window.location.href = res.data.data
              else reject('correct all values')
            } else {
              this.CryptoInfo = res.data
              console.info(this.$refs.tabCrypto.$refs.countdowntimer)
              this.$refs.tabCrypto.$refs.countdowntimer.timePassed = 0
            }
            resolve(true)
          })
          .catch(err => {
            reject('correct all values')
          })
      })      

    },
    validateStep3 () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('step-3').then(result => {
          if (result) {
            alert('Form submitted!')
            resolve(true)
          } else {
            reject('correct all values')
          }
        })
      })
    },
    fetch_provider_data () {     
      this.$store.dispatch('TransactionMng/fetchProviderMethods', this.payload)
        .then(res => { 
          this.$vs.loading.close('#loadingTab > .con-vs-loading')
          this.providerMethodList = res.data.data
        })
        .catch(err => {
          console.error(err) 
        })
    }
  },
  created () {
    if (!moduleTransactionMng.isRegistered) {
      this.$store.registerModule('TransactionMng', moduleTransactionMng)
      moduleTransactionMng.isRegistered = true
    }

    this.fetch_provider_data()
  },
  mounted () {
    this.$vs.loading({
      container: '#loadingTab',
      type: 'sound',
      scale: 1
    })     
  }
}
</script>